import { useCallback } from 'react';
import toast from 'react-hot-toast';

export function useNotifications() {
  const success = useCallback((message: string) => {
    toast.success(message, {
      duration: 5000,
      position: 'bottom-right',
    });
  }, []);

  const error = useCallback((message: string) => {
    toast.error(message, {
      duration: 7000,
      position: 'bottom-right',
    });
  }, []);

  const info = useCallback((message: string) => {
    toast(message, {
      duration: 4000,
      position: 'bottom-right',
    });
  }, []);

  return { success, error, info };
}